import { render } from "./ReportsGroupedPdf.vue?vue&type=template&id=0c4578ca"
import script from "./ReportsGroupedPdf.vue?vue&type=script&lang=js"
export * from "./ReportsGroupedPdf.vue?vue&type=script&lang=js"

import "./ReportsGroupedPdf.vue?vue&type=style&index=0&id=0c4578ca&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__